module.exports = __webpack_public_path__ + "img/vip1.30f5b7f9.png";